import { hasCapability, type User } from "../base";

export const materials = {
  update: (user: User) => hasCapability(user, "materials.update"),
};
